$(function () {
    // @vars
    // ---------------------------------------------------------------------------------------------------------------------
    var $location, $geolocation, autocomplete, geocoder, location

    // @initializations
    // ---------------------------------------------------------------------------------------------------------------------
    $location = $('#location')
    $geolocation = $('#geolocation')
    location = $location.get(0)

    if (typeof location === 'undefined') {
        return
    }

    // Wacht tot Google Maps volledig is ingeladen via de async script-tag
    function initGoogleFeatures() {
        if (typeof google !== 'undefined' && typeof google.maps !== 'undefined' && typeof google.maps.places !== 'undefined') {
            // Initialiseer pas als Google volledig beschikbaar is
            autocomplete = new google.maps.places.Autocomplete(location, { types: ['(regions)'] })
            geocoder = new google.maps.Geocoder()

            // Koppel de event listener voor autocomplete pas NADAT deze is aangemaakt
            google.maps.event.addListener(autocomplete, 'place_changed', function () {
                $('.form-region-select').submit()
            })

            console.log('Google Autocomplete & Geocoder succesvol geïnitialiseerd.')
        } else {
            // Nog niet geladen? Wacht 100ms en probeer opnieuw
            setTimeout(initGoogleFeatures, 100)
        }
    }

    // Start de controle-loop
    initGoogleFeatures()

    // @functions
    // ---------------------------------------------------------------------------------------------------------------------
    function sendData(data) {
        return $.ajax({
            url: CCM_REL + '/index.php/tools/packages/calendar/ajax.php',
            data: data,
            type: 'GET',
            dataType: 'json',
        })
    }

    // @events
    // -----------------------------------------------------------------------------------------------------------------

    // Geolocation Klik Handler
    $geolocation.on('click', function (eventObj) {
        eventObj.preventDefault()
        if (typeof navigator.geolocation !== 'undefined') {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    sendData({
                        action: 'session-store-geolocation',
                        position: position.coords,
                    }).always(function () {
                        // Maakt gebruik van .always() zodat de herlaadactie gegarandeerd doorgaat
                        window.location.reload()
                    })
                },
                function () {
                    alert('Sorry, no position available')
                },
                {
                    enableHighAccuracy: true,
                    maximumAge: 30000,
                    timeout: 27000,
                },
            )
        }
    })

    // Formulier Submit Handler
    $(document).on('submit', '.form-region-select', function (eventObj) {
        eventObj.preventDefault()

        if (typeof geocoder === 'undefined') {
            console.warn('Google Maps laadt nog, even geduld...')
            return
        }

        geocoder.geocode(
            {
                address: $location.val(),
            },
            function (results, status) {
                if (google.maps.GeocoderStatus.OK === status && results && results[0]) {
                    var components = results[0].address_components

                    for (var i = 0; i < components.length; i++) {
                        // Controleer of 'country' ergens in de types array voorkomt
                        if ($.inArray('country', components[i].types) !== -1) {
                            sendData({
                                action: 'session-store-country',
                                location: $location.val(),
                                country: components[i].short_name,
                            }).always(function () {
                                // .always() zorgt ervoor dat de reload start zodra de AJAX-call klaar is,
                                // ook als ajax.php een lege pagina of geen geldige JSON teruggeeft.
                                window.location.reload()
                            })

                            break // Stop de loop zodra het land gevonden is
                        }
                    }
                } else {
                    console.error('Geocode mislukt wegens status:', status)
                }
            },
        )
    })
})
